import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
  Flex,
} from '@core/ui-elements'
import { CSSProperties, FC, ReactElement } from 'react'
import { IconType } from 'react-icons'
import {
  MdCheckCircle,
  MdCheckCircleOutline,
  MdInfo,
  MdOutlineHighlightOff,
} from 'react-icons/md'
import { PiWarningFill } from 'react-icons/pi'

export interface IToastCard {
  title?: string | ReactElement
  description?: string | ReactElement
  variant?: 'error' | 'success' | 'warning' | 'info' | 'positive'
  onClose?: () => void
  style?: CSSProperties
  noIcon?: boolean
  customIcon?: IconType
}

/**
 * @deprecated
 */
export const ToastCard: FC<IToastCard> = ({
  title,
  description,
  variant = 'info',
  onClose,
  style,
  noIcon,
  customIcon,
}) => {
  const Icons = {
    error: MdOutlineHighlightOff,
    success: MdCheckCircleOutline,
    warning: PiWarningFill,
    info: MdInfo,
    positive: MdCheckCircle,
  }

  const IconComponent = customIcon ? customIcon : Icons[variant]

  return (
    <Alert style={style} variant={variant}>
      {!noIcon && <AlertIcon as={IconComponent} />}
      <Flex flexDirection={'column'} overflow={'hidden'} width={'100%'}>
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
      </Flex>
      {onClose ? (
        <CloseButton size={'sm'} variant="toast" onClick={onClose} />
      ) : null}
    </Alert>
  )
}
